












































































import _ from "lodash";
import { Component, Vue } from "vue-property-decorator";
import DashboardProjectItem from "./DashboardProjectItem.vue";
import AppHeader from "./AppHeader.vue";
import { Project, getAssignedProjects } from "@/api/project-api";
import { ProjectMessage, getUnreadReplyMessages } from "@/api/message-api";
import VChatMessage from "./VChatMessage.vue";
import ProjectMessageList from "@/components/ProjectMessageList.vue";
import VSearchBar from "../components/VSearchBar.vue";
import UserTaskList from "../task/ui/pages/UserTaskList.vue";
import SearchDashboardProjectBar from "../components/SearchDashboardProjectBar.vue";
import { getStatusCode } from "@/status";

@Component({
  components: {
    SearchDashboardProjectBar,
    DashboardProjectItem,
    AppHeader,
    UserTaskList,
    VSearchBar,
    VChatMessage,
    ProjectMessageList
  }
})
export default class DashboardPage extends Vue {
  assignedProjects: Project[] = [];
  projectMessages: ProjectMessage[] = [];
  resetLoadInfinite = 0;
  keyword = "";
  status = String(getStatusCode("施工中"));

  message: string = "";
  private canClick = true;
  private intervalId: ReturnType<typeof setInterval> | null = null;
  time: number = 30000;

  private async created() {
    this.assignedProjects = await getAssignedProjects(
      this.keyword,
      this.status
    );

    this.search(this.assignedProjects, this.status, this.keyword);
  }

  mounted() {
    this.intervalId = setInterval(() => {
      if (
        this.$route.name &&
        this.$route.name.toLowerCase() === "dashboard" &&
        this.canClick
      ) {
        this.handleClick();
      }
    }, this.time);
  }

  async handleClick() {
    if (this.canClick) {
      this.canClick = false;

      await this.loadMessages(this.assignedProjects);

      setTimeout(() => {
        this.canClick = true;
      }, this.time);
    }
  }

  async loadMessages(projects: Project[]) {
    try {
      this.projectMessages = this.assignedProjects.map(p => ({
        projectId: p.projectId,
        projectName: p.name,
        messageList: []
      }));

      const unreadMessages = await getUnreadReplyMessages(
        projects.map(p => p.projectId)
      );

      this.projectMessages = this.projectMessages.map(p => {
        const foundMessages = unreadMessages.find(
          (message: any) => message.projectId === p.projectId
        );
        return {
          ...p,
          messageList: foundMessages ? foundMessages.messageList : []
        };
      });
    } catch (error) {
      console.error("Error loading messages:", error);
    }
  }

  canReadMaster() {
    return this.$store.getters.permissions.includes("service/master_read");
  }

  async search(projects: Project[], status: any, keyword: any) {
    this.message = "";
    this.status = status;
    this.keyword = keyword;
    this.resetLoadInfinite += 1;

    this.assignedProjects = _.orderBy(projects, "created", "desc");

    if (!this.assignedProjects.length) {
      this.message = "検索結果はありません";
    }
    await this.loadMessages(this.assignedProjects);
  }

  async loadInfinite($state: any) {
    const loadedProjectItems: Project[] = await getAssignedProjects(
      this.keyword,
      this.status,
      this.assignedProjects.length
    );

    if (loadedProjectItems.length) {
      if (loadedProjectItems.length == 0) {
        this.assignedProjects = loadedProjectItems;
        await this.loadMessages(this.assignedProjects);
      } else {
        this.assignedProjects = this.assignedProjects.concat(
          loadedProjectItems
        );
        await this.loadMessages(this.assignedProjects);
      }
      $state.loaded();
    } else {
      $state.complete();
    }

    if (!this.assignedProjects.length) {
      this.message = "検索結果はありません";
    }
  }

  beforeDestroy() {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
    }
  }
}
